/**
 * Shared styling for the objection / FAQ / New Inquiry cards on the call and
 * training timelines.
 *
 * The "Stored answer" and "AI generated answer" labels are muted helper text
 * in the normal weight: in bold they pulled the eye away from the answers
 * they introduce (owner, 2026-10-01).
 */
export const ANSWER_LABEL_CLASS = 'mb-1 font-normal text-ink-muted';
